export type SkuCategory = "sofa" | "bed" | "pillow" | "other";

/**
 * Product category derived from the SKU's two-letter category prefix. Sofas/sectionals use
 * "DL", beds and headboards use "DB", pillows use "SP". Anything else — including chairs and
 * ottomans, which have no dedicated prefix in the catalog — is treated as "other".
 */
export const getCategoryFromSku = (sku: string): SkuCategory => {
  const prefix = (sku || "").trim().toUpperCase().slice(0, 2);

  switch (prefix) {
    case "DL":
      return "sofa";
    case "DB":
      return "bed";
    case "SP":
      return "pillow";
    default:
      return "other";
  }
};

/**
 * Whether a product of this SKU carries a leg. Only sofas/sectionals (DL) and bed
 * components (DB) have a leg segment; pillows, chairs, and ottomans do not.
 */
export const skuHasLeg = (sku: string): boolean => {
  const category = getCategoryFromSku(sku);
  return category === "sofa" || category === "bed";
};
